import clsx from 'clsx';

interface IProps {
  isLoading: boolean;
  children?: React.ReactNode;
  spinnerCls?: string;
}

function SpinnerBox({ isLoading, children, spinnerCls }: IProps) {
  const spinnerClsx = clsx({
    'c-loader': isLoading,
  });
  const boxClsx = clsx({
    'h-fit': true,
    relative: isLoading,
  });
  const spinnerBoxClsx = clsx({
    'bg-black bg-opacity-5 absolute inset-0 flex items-center justify-center z-50': isLoading,
    [spinnerCls]: isLoading,
  });
  return (
    <div className={boxClsx}>
      <div className={spinnerBoxClsx}>
        <div className={spinnerClsx}></div>
      </div>
      {children}
    </div>
  );
}

export { SpinnerBox };
